<button
  type="button"
  class="btn btn--icon cs-btn"
  [class.profile-header]="profileHeader"
  (click)="openCleverStaffExportModal()"
  [disabled]="disabled || limitAccess || isModalPending">
  <svg width="16" height="16" class="icon">
    <use xlink:href="#cs-import-icon"></use>
  </svg>
</button>
